// extracted by mini-css-extract-plugin
export default {"access-item":"subMerchSlug_access-item__XFPSX","accessItem":"subMerchSlug_access-item__XFPSX"};